import { render, staticRenderFns } from "./FrotaInterativa.vue?vue&type=template&id=71599fa2&"
import script from "./FrotaInterativa.vue?vue&type=script&lang=js&"
export * from "./FrotaInterativa.vue?vue&type=script&lang=js&"
import style0 from "./FrotaInterativa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports